import config from './config';
import {HubConnectionBuilder} from '@aspnet/signalr';

const connection = new HubConnectionBuilder().withUrl(config.mixiplyUri  + "liveDataHub").build();
export default connection;